/**
 * Remington 870, as a thing you can carry. The gun itself is `sim/weapons/guns/remington870.ts`.
 */

import { NO_ARMOR } from '@/sim/combat/armorMitigation';
import type { WeaponItem } from '@/sim/items/itemContract';

export const REMINGTON870_ITEM = {
  id: 'remington870',
  kind: 'weapon',
  label: 'Remington 870',
  description:
    'Nine pellets of unambiguous opinion. Effective to the far side of a room and no further.',
  rarity: 'uncommon',
  weightKg: 3.4,
  stackLimit: 1,
  equip: {
    slots: ['primaryWeapon'],
    statDeltas: {},
    armor: NO_ARMOR,
    damageModifiers: [],
  },
  weaponId: 'remington870',
} as const satisfies WeaponItem;
